import React from 'react';

const money = (v) => `GHS ${Number(v || 0).toFixed(2)}`;

const ReviewStep = ({
  selectedPlan,
  selectedData,
  selectedOS,
  selectedVariant,
  quantity,
  billingCycle,
  pricePerMonth,
  totalPrice,
  subtotal,
  nhil,
  getfund,
  vat,
  isCustom,
  customSpecs,
  dedicatedIPs,
  ipPriceTotal,
  IP_PRICE_PER_UNIT,
  extraStorage,
  storagePriceTotal,
  STORAGE_PRICE_PER_UNIT,
  autoRenewal,
  startDate,
  formattedExpirationDate,
  agreeTerms,
  setAgreeTerms
}) => {
  const showBreakdown = subtotal !== undefined;
  return (
    <div className="space-y-4">
      {(selectedData || isCustom) && (
        <div className="border rounded-xl p-4 mb-6 bg-[#022A52] text-sm">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <p><strong>Plan:</strong> {selectedPlan}</p>
              <p><strong>OS:</strong> {selectedOS}{selectedVariant ? ` (${selectedVariant})` : ''}</p>
              <p><strong>Qty:</strong> {quantity}</p>
              <p><strong>Billing:</strong> {billingCycle}</p>
            </div>
            <div>
              {isCustom && customSpecs ? (
                <>
                  <p><strong>CPU:</strong> {customSpecs.cpuCores} vCPU</p>
                  <p><strong>RAM:</strong> {customSpecs.ramGb} GB</p>
                  <p><strong>Storage:</strong> {customSpecs.nvmeGb} GB NVMe / {customSpecs.hddGb} GB SSD</p>
                </>
              ) : (
                <>
                  <p><strong>CPU:</strong> {selectedData.cpu}</p>
                  <p><strong>RAM:</strong> {selectedData.ram}</p>
                  <p><strong>Storage:</strong> {selectedData.storage}</p>
                </>
              )}
            </div>
          </div>
          
          {/* Dedicated IPs Display */}
          {dedicatedIPs > 0 && (
            <p><strong>Dedicated IPs:</strong> {dedicatedIPs} × GHS {IP_PRICE_PER_UNIT.toFixed(2)} = GHS {ipPriceTotal.toFixed(2)}/month</p>
          )}
          
          {/* Extra Storage Display */}
          {(extraStorage.nvme > 0 || extraStorage.hdd > 0) && (
            <div className="mt-2">
              <p><strong>Extra Storage:</strong></p>
              {extraStorage.nvme > 0 && (
                <p className="ml-4">• {extraStorage.nvme}GB NVMe: +GHS {(extraStorage.nvme / 50 * STORAGE_PRICE_PER_UNIT).toFixed(2)}/month</p>
              )}
              {extraStorage.hdd > 0 && (
                <p className="ml-4">• {extraStorage.hdd}GB SSD: +GHS {(extraStorage.hdd / 50 * STORAGE_PRICE_PER_UNIT).toFixed(2)}/month</p>
              )}
              <p className="ml-4 text-green-400">Total storage extra: GHS {storagePriceTotal.toFixed(2)}/month</p>
            </div>
          )}
          
          <p><strong>Auto-Renewal:</strong> {autoRenewal ? '✅ Enabled' : '❌ Disabled'}</p>
          <p><strong>Start:</strong> {startDate}</p>
          <p><strong>Expires:</strong> {formattedExpirationDate}</p>
          <p className="mt-3 text-gray-300">{money(pricePerMonth)}/month (ex-levy)</p>
          {showBreakdown ? (
            <div className="mt-2 space-y-1 border-t border-[#033A6A] pt-2">
              <p className="text-gray-200">SUB-TOTAL: {money(subtotal)}</p>
              <p className="text-gray-400 text-xs">NHIL (2.5%): {money(nhil)}</p>
              <p className="text-gray-400 text-xs">GETFund (2.5%): {money(getfund)}</p>
              <p className="text-gray-400 text-xs">VAT (15% on subtotal + levies): {money(vat)}</p>
              <p className="text-2xl text-green-400 font-bold mt-1">TOTAL: {money(totalPrice)}</p>
            </div>
          ) : (
            <p className="text-2xl text-green-400 font-bold mt-1">GHS{totalPrice}</p>
          )}
        </div>
      )}

      <div className="mb-6 flex items-start">
        <input
          type="checkbox"
          checked={agreeTerms}
          onChange={(e) => setAgreeTerms(e.target.checked)}
          className="mt-1 h-4 w-4"
        />
        <label className="ml-3 text-sm">
          I agree to the <span className="text-green-400">Terms & Conditions</span>.
        </label>
      </div>
    </div>
  );
};

export default ReviewStep;